import Vue from 'vue';
import Vuex from 'vuex';
import stepper from './store/stepper';
import angebotPrivat from './store/angebotPrivat';
import angebotPrivatAenderung from './store/angebotPrivatAenderung';
import gewerbe from './store/angebotGewerbe';
import staticPagesContent from './store/staticPagesContent';
import praemien from './store/praemien.js';
import gewerbePraemien from './store/gewerbePraemien';
import user from './store/user.js';
//TODO Deaktivate Logger in production 1
import createLogger from 'vuex/dist/logger';

// eslint-disable-next-line
function disableLogging () {
  try {
    let methods = [ 'assert', 'debug', 'dir', 'dirxml', 'error', 'exception', 'group', 'groupEnd', 'info', 'log', 'table', 'time', 'timeEnd', 'trace', 'warn'];
    methods.forEach(method => console[method] = function() {});
  }
  catch (err) {
    // continue regardless of error
  }
}


Vue.use(Vuex);

let env = { 
  environment: undefined,
  versioninfo: undefined
};

try {
  env.environment = process.env.NODE_ENV;
  if (process.env.NODE_ENV === "development") {
    console.log(env.environment.toUpperCase());
  } else if (process.env.NODE_ENV === "production") {
    disableLogging();
  } else {
    console.err("NODE_ENV invalid: " + env.environment);
  }
} catch (err) {
  console.err("process environment not available!");
}
try {
  env.versioninfo = process.env.VUE_APP_COMMIT_HASH;
} catch (err) {
  console.err("process.env.VUE_APP_COMMIT_HASH not available!");
  env.versioninfo = 'ver-start' + (new Date).toISOString().replace(/:/g, "-") + '_anylocal'  + 'ver-end';
}

// quote from vuex docs: Do not enable strict mode when deploying for production!
const strictState = env.environment !== 'production';

// TODO: move user from base data to separate module, or root state

export default new Vuex.Store({
  state() {
    return {
      env
    };
  },
  modules: {
    user,
    praemien,
    s: stepper,
    b: angebotPrivat,
    editContract: angebotPrivatAenderung,
    staticPagesContent,
    gewerbe,
    gewerbePraemien
  },
  // Deactivate Logger in production
  plugins: env.environment === 'production' ? [] : [createLogger({
    collapsed: true, // auto-expand logged mutations

    filter(mutation, stateBefore, stateAfter) {
      // returns `true` if a mutation should be logged
      // `mutation` is a `{ type, payload }`
      //return mutation.type !== "aBlacklistedMutation"
      if (mutation || stateBefore || stateAfter) return true;
    },

    transformer(state) {
      // transform the state before logging it.
      // for example return only a specific sub-tree
      //return state.subTree
      return state;
    },
    mutationTransformer(mutation) {
      // mutations are logged in the format of `{ type, payload }`
      // we can format it any way we want.
      //return mutation.type
      return mutation;
    },
    logger: console, // implementation of the `console` API, default `console`
  })],

  mutations: {

    /**
     * universal, deep, multivalue/object basesed
     * change mutation
     * @param {any} state
     * @param {any} payload
     */
    setObject(state, payload) {
      mergeDeep(state, payload);
    },
    addWatched(state, payload) {
      Vue.set(payload.target, payload.key, (payload.value) ? payload.value : "initial");
    }
  },
  strict: strictState
});

/** Local helper functions TODO maybe use own helper library or stuff like lodash */
/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

/**
 * Deep merge two objects. !make sure sources is not a reference to target -> loop!
 * @param target
 * @param sources
 */
function mergeDeep(target, ...sources) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  } else if (Array.isArray(target) && isObject(source)) {
    for (const key of Object.keys(source)) {
      if (isObject(source[key])) {
        //todo implicit string to number maybe key of intead of key in
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }
  return mergeDeep(target, ...sources);
}
